import React from "react";

const QrCodeIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      className={cls}
    >
      <path
        d="M3.5 9.88599H9.625V3.76099H3.5V9.88599ZM5.25 5.51099H7.875V8.13599H5.25V5.51099ZM17.5 3.76099H11.375V9.88599H17.5V3.76099ZM15.75 8.13599H13.125V5.51099H15.75V8.13599ZM3.5 17.761H9.625V11.636H3.5V17.761ZM5.25 13.386H7.875V16.011H5.25V13.386ZM2.625 19.511H6.125V21.261H2.625C1.17775 21.261 0 20.0832 0 18.636V15.136H1.75V18.636C1.75 19.1181 2.14287 19.511 2.625 19.511ZM19.25 15.136H21V18.636C21 20.0832 19.8223 21.261 18.375 21.261H14.875V19.511H18.375C18.8571 19.511 19.25 19.1181 19.25 18.636V15.136ZM21 2.88599V6.38599H19.25V2.88599C19.25 2.40386 18.8571 2.01099 18.375 2.01099H14.875V0.260986H18.375C19.8223 0.260986 21 1.43874 21 2.88599ZM1.75 6.38599H0V2.88599C0 1.43874 1.17775 0.260986 2.625 0.260986H6.125V2.01099H2.625C2.14287 2.01099 1.75 2.40386 1.75 2.88599V6.38599ZM11.375 15.136H14V17.761H11.375V15.136ZM14.875 14.261V11.636H17.5V14.261H14.875ZM11.375 11.636H14V14.261H11.375V11.636Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default QrCodeIcon;
